<template>
  <div id="app">
    <router-view />
    <notifications group="alert" position="bottom center" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Cookies from "js-cookie";
import { Constants } from "@/constants";

export default {
  name: "App",

  methods: mapActions(["setUser", "setAuthStatus", "setToken"]),

  mounted() {
    // mount only after login
    const user = Cookies.get(Constants.LOGIN_USER);
    if (user) {
      this.setUser();
      this.setToken();
      this.setAuthStatus();
      this.$eventHub.$emit("app-mounted");
    }
  },
};
</script>
